<div id="home-realestate" class="container  px-4">
  <div class="row">
    <div class="col-12 col-lg-5 ps-3 ps-lg-4 border-linea border-radius-2 border-secondary-estate-500">
      <p class="primary-800 tabs">SEGO <span class="secondary-estate-500">Real Estate</span></p>
      <h1 class="primary-900">Invierte en el <br>sector inmobiliario</h1>
    </div>
    <div class="col-12 col-lg-7 gx-0 d-flex flex-column justify-content-end">
      <p class="p2-medium neutral-500 my-2">
        Invierte en las mejores <span class="p2-bold">oportunidades</span> y <span class="p2-bold">rentabiliza
      tu capital</span> a través de SEGO Real Estate.
    </p>
    <div class="link-container mb-2">
      @if (platformId === 'REALESTATE') {
        <a id="home-realestate-claves" routerLink="/como-funciona"
          class="link1-bold primary-900 d-flex align-items-center"
          title="Descubre los trucos para invertir en Real Estate">
          <span class="me-1 d-none d-lg-flex">Descubre los trucos para invertir en
          Real Estate</span>
          <span class="me-1 d-flex d-lg-none">Trucos para invertir en Real
          Estate</span>
          <span class="material-symbols-outlined">arrow_forward</span>
        </a>
      }
      @if (platformId !== 'REALESTATE') {
        <a id="home-realestate-claves"
          href="{{domainUrl + '/como-funciona'}}"
          target="{{platformId === 'VENTURE' || platformId === 'CREATIVE' ? '_self': '_blank'}}"
          class="link1-bold primary-900 d-flex align-items-center"
          title="Descubre los trucos para invertir en Real Estate">
          <span class="me-1 d-none d-lg-flex">Descubre los trucos para invertir en
          Real Estate</span>
          <span class="me-1 d-flex d-lg-none">Trucos para invertir en Real
          Estate</span>
          <span class="material-symbols-outlined">arrow_forward</span>
        </a>
      }
    </div>
  </div>
  <div class="col-12 mt-3 mb-2 bg-primary-100 border-radius-4 p-2">
    <div class="mx-3 mx-lg-4">
      <p class="p3-regular neutral-900 mb-0">Producto ofrecido por SociosInversores 2010 SL,
        Proveedor de Servicios de Financiación Participativa, supervisado por CNMV y registrado en la
        Autoridad Europea de Supervisión de Valores y Mercados (AEVM) con Licencia nº 7. Sujeto al
      Reglamento (UE) 2020/1503 del Parlamento Europeo.</p>
    </div>
  </div>
</div>

@if (isLoading) {
  <div class="mt-5 p-5">
    <app-is-loading [color]="'realestate'"></app-is-loading>
  </div>
}

@if (!isLoading && oportunidadRealEstate && oportunidadRealEstate.galeria) {
  <div class="row mt-3 mt-lg-4 fadein ">
    <div class="col-12 gx-0 mx-auto">
      <app-ficha-home [isLogged]="isLogged" [oportunidadRealEstate]="oportunidadRealEstate"
        [domainUrl]="domainUrl"
      [target]="(platformId === 'VENTURE' || platformId === 'REALESTATE' || platformId === 'CREATIVE') ? '_self': '_blank'"></app-ficha-home>
    </div>
  </div>
}

@if (!isLoading && (!oportunidadRealEstate || !oportunidadRealEstate.proyectoId || !oportunidadRealEstate.galeria)) {
  <div
    class="row mt-3 mt-lg-4 fadein">
    <div class="col-12 gx-0 mt-4">
      <app-subiendo-oportunidades [line]="'estate'"></app-subiendo-oportunidades>
    </div>
  </div>
}

<div class="row mt-4">
  <div class="col-12 col-lg-5 col-xl-4 gx-0 gx-lg-4 mx-auto text-center">
    @if (platformId === 'REALESTATE') {
      <a id="home-oportunidades-realestate" class="btn btn-primary w-100"
        title="Ver todas las oportunidades" routerLink="/oportunidades-inversion">
        <div class="d-flex align-items-center justify-content-center">
          <span>Ver todas las oportunidades</span> <span
        class="material-symbols-outlined ms-2">chevron_right</span>
      </div>
    </a>
  }
  @if (platformId !== 'REALESTATE') {
    <a d="home-oportunidades-realestate" class="btn btn-primary w-100"
      title="Ver todas las oportunidades" href="{{domainUrl + '/oportunidades-inversion'}}"
      target="{{platformId === 'VENTURE' || platformId === 'CREATIVE' ? '_self': '_blank'}}">
      <div class="d-flex align-items-center justify-content-center">
        <span>Ver todas las oportunidades</span> <span
      class="material-symbols-outlined ms-2">chevron_right</span>
    </div>
  </a>
}
</div>
</div>
</div>